var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card-text',{staticClass:"overline pa-0"},[_c('span',{staticClass:"dot",style:(("--color: " + _vm.color))}),_vm._v(" "+_vm._s(_vm.tag.title))])}
var staticRenderFns = []

export { render, staticRenderFns }